export const SelectTab = (state, currentTab) => ({
  ...state,
  currentTab
})
